import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '@app/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.scss'],
})
export class ChatBoxComponent implements OnInit {
  assetUrl = environment.assetUrl;
  msgbox = '';
  @Input() type: string = 'message';
  @Input() username: string = '';
  @Output() send = new EventEmitter();
  @Output() reply = new EventEmitter();
  constructor(public _user: UserService) {}

  ngOnInit(): void {}
}
